import { create } from 'zustand';
import superAdminApi from '../lib/superAdminApi';

export const useSuperAdminStore = create((set, get) => ({
  user: JSON.parse(localStorage.getItem('super_admin_user') || 'null'),
  token: localStorage.getItem('super_admin_token') || null,
  isAuthenticated: !!localStorage.getItem('super_admin_token'),
  isLoading: false,
  error: null,

  login: async (email, password) => {
    set({ isLoading: true, error: null });
    try {
      const res = await superAdminApi.post('/super/auth/login', { email, password });
      const { user, accessToken } = res.data;
      localStorage.setItem('super_admin_token', accessToken);
      localStorage.setItem('super_admin_user', JSON.stringify(user));
      set({ user, token: accessToken, isAuthenticated: true, isLoading: false });
      return { success: true };
    } catch (err) {
      const message = err.status === 401
        ? 'Invalid email or password'
        : err.status >= 500
          ? 'Server error — please try again later'
          : err.message || 'Something went wrong';
      set({ error: message, isLoading: false });
      return { success: false, message };
    }
  },

  logout: () => {
    localStorage.removeItem('super_admin_token');
    localStorage.removeItem('super_admin_user');
    set({ user: null, token: null, isAuthenticated: false, error: null });
  },

  checkAuth: async () => {
    const token = localStorage.getItem('super_admin_token');
    if (!token) return;
    try {
      const res = await superAdminApi.get('/super/auth/me');
      const user = res.data.user;
      localStorage.setItem('super_admin_user', JSON.stringify(user));
      set({ user, isAuthenticated: true });
    } catch {
      get().logout();
    }
  },

  setUser: (user) => {
    localStorage.setItem('super_admin_user', JSON.stringify(user));
    set({ user });
  },

  clearError: () => set({ error: null }),
}));
